export default function Task({todo,deleteToDo,index,completeToDo,updateToDo}) {
    return (
        <div className="card container mt-3">
          <div className="row">
            <div className="col-sm-6 col-md-8 mb-2 mt-2">
              <li onClick={()=>completeToDo(index)} className={todo.completed?"completedTask":"pendingTask"}>{todo.task == " "?"Add your tasks":todo.task}</li>
            </div>
            <div className="col-sm-6 col-md-4 my-2">
              <button className="btn btn-danger btn-sm ms-5" onClick={()=>updateToDo(index)}>Edit</button>
              <button className="btn btn-close float-end mt-1" onClick={()=>deleteToDo(index)}></button>
            </div>
          </div>
        </div>
    );
  }
  